class FacetFiltersForm extends HTMLElement {
  static _reqToken = 0;
  static _aborter = null;

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = (typeof debounce === 'function')
      ? debounce((event) => this.onSubmitHandler(event), 300)
      : (evt => this.onSubmitHandler(evt));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper && typeof onKeyUpEscape === 'function') {
      facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }
  }

  connectedCallback() {
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((el) => {
      el.classList.toggle("disabled", disable);
    });
  }

  static fireCustomEvent(options) {
    const facetsChange = new CustomEvent("facets:change", {
      bubbles: true,
      cancelable: true,
      detail: { desc: "facets changed", ...options },
    });
    document.dispatchEvent(facetsChange);
  }

  static _beginRequest() {
    FacetFiltersForm._reqToken += 1;
    if (FacetFiltersForm._aborter) {
      try { FacetFiltersForm._aborter.abort(); } catch (_) {}
    }
    FacetFiltersForm._aborter = new AbortController();
    return { token: FacetFiltersForm._reqToken, signal: FacetFiltersForm._aborter.signal };
  }
  static _isStale(token) {
    return token !== FacetFiltersForm._reqToken;
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const { token, signal } = FacetFiltersForm._beginRequest();
    const sections = FacetFiltersForm.getSections();
    if (!sections.length) return;

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (el) => el.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, token)
        : FacetFiltersForm.renderSectionFromFetch(url, event, token, signal);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, token, signal) {
    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (FacetFiltersForm._isStale(token)) return;

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newActiveFilters = parsed.querySelector('[active-filters]')?.innerText?.replace('var activeFilters = ', '');
        if (newActiveFilters) window.activeFilters = JSON.parse(newActiveFilters);

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderPagination(html);

        if (typeof initializeScrollAnimationTrigger === "function") {
          initializeScrollAnimationTrigger(parsed);
        }
      })
      .catch((err) => {
        if (err?.name !== 'AbortError') console.error('Facet fetch error:', err);
      })
      .finally(() => {
        if (!FacetFiltersForm._isStale(token)) FacetFiltersForm.fireCustomEvent();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, token) {
  if (FacetFiltersForm._isStale(token)) return;
  const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
  const parsed = new DOMParser().parseFromString(html, 'text/html'); // ADDED
  FacetFiltersForm.renderFilters(html, event);
  FacetFiltersForm.renderProductGridContainer(html);
  FacetFiltersForm.renderPagination(html);

  if (typeof initializeScrollAnimationTrigger === "function") {
    initializeScrollAnimationTrigger(parsed); // CHANGED (was: html)
  }

  FacetFiltersForm.fireCustomEvent();
  }

  static renderProductGridContainer(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const target = document.getElementById("ProductGridContainer");
    const fresh  = doc.getElementById("ProductGridContainer");
    if (target && fresh) target.innerHTML = fresh.innerHTML;
  }

  static renderPagination(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const target = document.getElementById("AjaxinatePagination");
    const fresh  = doc.getElementById("AjaxinatePagination");
    if (target && fresh) target.innerHTML = fresh.innerHTML;
  }

  static renderProductCount(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const count = doc.getElementById("ProductCount")?.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    if (container && count != null) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (containerDesktop && count != null) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static syncActiveClasses() {
    document.querySelectorAll('.form-checkbox__input').forEach(cb => {
      const wrap = cb.closest('.form-checkbox');
      if (!wrap) return;
      const textLabel = wrap.querySelector('.form-checkbox__label');
      const swatchWrap = wrap.querySelector('.filter__color-swatch--wrapper');
      if (textLabel)  textLabel.classList.toggle('wd__filter-active', cb.checked);
      if (swatchWrap) swatchWrap.classList.toggle('wd__filter-active', cb.checked);
    });
  }

  static renderFilters(html, event) {
    const doc = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = doc.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    const matchesIndex = (el) => {
      const jsFilter = event?.target?.closest?.(".js-filter");
      return jsFilter ? el.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((el) => !matchesIndex(el));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    if (facetsToRender.length === 0 && !countsToRender) {
      const newForm = doc.querySelector("#FacetFiltersForm");
      const curForm = document.querySelector("#FacetFiltersForm");
      if (newForm && curForm) curForm.innerHTML = newForm.innerHTML;
      FacetFiltersForm.renderActiveFacets(doc);
      FacetFiltersForm.renderAdditionalElements(doc);
      FacetFiltersForm.syncActiveClasses();
      return;
    }

    facetsToRender.forEach((el) => {
      const container = document.querySelector(`.js-filter[data-index="${el.dataset.index}"]`);
      if (!container) return;
      container.innerHTML = "";
      container.appendChild(el.cloneNode(true));
    });

    FacetFiltersForm.renderActiveFacets(doc);
    FacetFiltersForm.renderAdditionalElements(doc);

    if (countsToRender && event?.target) {
      const target = event.target.closest(".js-filter");
      if (target) FacetFiltersForm.renderCounts(countsToRender, target);
    }

    FacetFiltersForm.syncActiveClasses();
  }

  static renderActiveFacets(html) {
    [".active-facets"].forEach((selector) => {
      const fresh = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((selector) => {
      const fresh = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
  }

  static renderCounts(source, target) {
    const srcSelected = source.querySelector(".facets__selected");
    const tgtSelected = target.querySelector(".facets__selected");
    const srcSummary  = source.querySelector(".facets__summary");
    const tgtSummary  = target.querySelector(".facets__summary");

    if (srcSelected && tgtSelected) tgtSelected.outerHTML = srcSelected.outerHTML;
    if (srcSummary  && tgtSummary)  tgtSummary.outerHTML  = srcSummary.outerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams ? "?" + searchParams : ""}`,
    );
  }

  static getSections() {
    const grid = document.getElementById("product-grid");
    return grid ? [{ section: grid.dataset.id }] : [];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");

    if (event.target.classList?.contains("mobile-facets__checkbox")) {
      const searchParams = this.createSearchParams(event.target.closest("form"));
      this.onSubmitForm(searchParams, event);
      return;
    }

    const forms = [];
    const isMobile = event.target.closest("form")?.id === "FacetFiltersFormMobile";

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (["FacetSortForm", "FacetFiltersForm", "FacetSortDrawerForm"].includes(form.id)) {
          document.querySelectorAll(".no-js-list").forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === "FacetFiltersFormMobile") {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const href = event.currentTarget?.href || "";
    const qIndex = href.indexOf("?");
    const url = qIndex === -1 ? "" : href.slice(qIndex + 1);
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev   = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((el) =>
      el.addEventListener("input", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput?.value) minInput?.setAttribute("max", maxInput.value.trim());
    if (minInput?.value) maxInput?.setAttribute("min", minInput.value.trim());
    if (minInput && minInput.value === "") maxInput?.setAttribute("min", 0);
    if (maxInput && maxInput.value === "") {
      const resetMax = maxInput.getAttribute("max");
      if (resetMax) minInput?.setAttribute("max", resetMax);
    }
  }

  adjustToValidValues(input) {
    const fromInput = this.querySelector('[name="filter.v.price.gte"]');
    const toInput   = this.querySelector('[name="filter.v.price.lte"]');
    const sliderEl  = this.querySelector(".f-price__slider");

    const globalMax = sliderEl ? Number(sliderEl.dataset.max) || 999999 : 999999;

    let fromValue = parseFloat(fromInput?.value) || 0;
    let toValue   = parseFloat(toInput?.value) || 0;

    if (input.name === "filter.v.price.gte") {
      if (fromValue < 0) fromValue = 0;
      if (fromValue > toValue) fromValue = toValue;
      if (fromValue > globalMax) fromValue = globalMax;
      if (fromInput) fromInput.value = fromValue;
    } else {
      if (toValue < fromValue) toValue = fromValue;
      if (toValue > globalMax) toValue = globalMax;
      if (toInput) toInput.value = toValue;
    }
  }
}
customElements.define("price-range", PriceRange);

document.addEventListener('click', (e) => {
  const clearAll = e.target.closest('.active-facets .filter__remove');
  if (!clearAll) return;
  e.preventDefault();

  const form = document.querySelector('#FacetFiltersForm');
  if (!form) return;

  if (FacetFiltersForm._aborter) {
    try { FacetFiltersForm._aborter.abort(); } catch (_) {}
  }

  form.querySelectorAll('.form-checkbox__input:checked').forEach(cb => { cb.checked = false; });
  const min = form.querySelector('[name="filter.v.price.gte"]');
  const max = form.querySelector('[name="filter.v.price.lte"]');
  if (min) min.value = '';
  if (max) max.value = '';

  FacetFiltersForm.syncActiveClasses();
  const params = new URLSearchParams(new FormData(form))
  params.delete('sort_by');
  FacetFiltersForm.renderPage(params.toString(), e);
});


document.addEventListener('click', (e) => {
  const labelOrSwatch = e.target.closest('.form-checkbox__label, .filter__color-swatch--wrapper, .input-decorator');
  if (!labelOrSwatch) return;
  const root = labelOrSwatch.closest('.form-checkbox');
  const cb = root?.querySelector('.form-checkbox__input');
  if (!cb) return;
  e.preventDefault();
  cb.checked = !cb.checked;
  cb.dispatchEvent(new Event('change', { bubbles: true }));
});


const _wdDebounce = (typeof debounce === 'function')
  ? debounce
  : ((fn, ms=120) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn.apply(null, a), ms); }; });

const submitAfterChange = _wdDebounce((form, evt) => {
  if (FacetFiltersForm._aborter) {
    try { FacetFiltersForm._aborter.abort(); } catch (_) {}
  }
  const params = new URLSearchParams(new FormData(form)).toString();
  FacetFiltersForm.renderPage(params, evt);
}, 120);

document.addEventListener('change', (e) => {
  if (!e.target.matches('.form-checkbox__input, [name="filter.v.price.gte"], [name="filter.v.price.lte"]')) return;
  const form = e.target.closest('#FacetFiltersForm');
  if (!form) return;
  submitAfterChange(form, e);
});
